module.exports = __webpack_public_path__ + "img/c-img-3.56762772.jpg";